import useInput from "../hooks/use-input";
import { useFormContext } from "../contexts/form-context";
import { useLayoutEffect } from "react";

const FormHiddenInput = (props) => {
  const { ref } = useInput({ ...props, defaultValue: props.value });

  const { register, deregister } = useFormContext();

  useLayoutEffect(() => {
    if (!props.ignore) {
      register(props.id || props.name, ref);

      return () => {
        deregister(props.id || props.name);
      };
    }
  }, []);

  return <input type="hidden" {...props} />;
};

export default FormHiddenInput;
